import { createActionTypesForResourceName } from "../create_action_types_for_resource_name";

/**
 * Create a set of actions for a json api resource reducer
 * @param {string} name the resource name
 * @returns {Object} actions object
 */
export function createResourceActions(name) {
  const actionTypes = createActionTypesForResourceName(name);

  return {
    /**
     * Append objects to store and replace meta data
     * @param {array|string} contexts array of context strings or context string
     * @param {object} data
     * @param {array} ids
     * @param {object} links
     * @param {object} meta
     */
    replaceAction: ({ contexts, data, ids, links, meta }) => {
      if (typeof contexts == "string") {
        contexts = [contexts];
      }
      return {
        type: actionTypes.replace,
        payload: {
          contexts,
          data,
          ids,
          links,
          meta
        }
      };
    },

    /**
     * Append objects to store and replace meta data
     * @param {array|string} contexts array of context strings or context string
     * @param {object} data
     * @param {array} ids
     * @param {object} links
     * @param {object} meta
     */
    populateAction: ({ contexts, data, ids, links, meta }) => {
      if (typeof contexts == "string") {
        contexts = [contexts];
      }
      return {
        type: actionTypes.populate,
        payload: {
          contexts,
          data,
          ids,
          links,
          meta
        }
      };
    },

    populatePatchAction: ({ data, ids }) => {
      return {
        type: actionTypes.populatePatch,
        payload: {
          data,
          ids
        }
      };
    },

    populatePostAction: ({ data }) => {
      return {
        type: actionTypes.populatePost,
        payload: {
          data
        }
      };
    },

    /**
     * Action creator to delete a resource
     * @param {Object} options
     * @param {string} context the context
     * @param {string} id the resource id
     */
    deleteAction: ({ context, id }) => {
      return {
        type: actionTypes.delete,
        payload: {
          context,
          id
        }
      };
    },

    /**
     * Action creator to delete a resource
     * @param {Object} options
     * @param {string} context the context
     * @param {string} id the resource id
     * @param {Object} replaceData data to replace deleted resource
     */
    deleteActionWithStatusById: ({ context, id, replaceData }) => {
      return {
        type: actionTypes.deleteWithStatusById,
        payload: {
          context,
          id,
          replaceData
        }
      };
    },

    /**
     * @param {string} context
     * @param {string} loadState
     * @returns {Object} redux action
     */
    setLoadStateForContextAction: (context, loadState) => {
      return {
        type: actionTypes.setLoadStateForContext,
        payload: {
          context,
          loadState
        }
      };
    },

    /**
     * Set loading state for context
     * @param {array|string} contexts
     */
    loadingForContextAction: contexts => {
      let contextsArray = contexts;
      if (typeof contexts == "string") {
        contextsArray = [contexts];
      }
      return {
        type: actionTypes.loadingForContext,
        payload: {
          contexts: contextsArray
        }
      };
    },

    /**
     * @deprecated
     */
    loadingMoreForContextAction: contexts => {
      if (typeof contexts == "string") {
        contexts = [contexts];
      }
      return {
        type: actionTypes.loadingMoreForContext,
        payload: {
          contexts
        }
      };
    },

    /**
     * @deprecated
     */
    loadErrorForContextAction: contexts => {
      if (typeof contexts == "string") {
        contexts = [contexts];
      }
      return {
        type: actionTypes.loadErrorForContext,
        payload: {
          contexts
        }
      };
    },

    loadingPostAction: () => {
      return {
        type: actionTypes.loadingPost
      };
    },

    loadErrorPostAction: () => {
      return {
        type: actionTypes.loadErrorPost
      };
    },

    loadingPatchAction: ids => {
      return {
        type: actionTypes.loadingPatch,
        payload: {
          ids
        }
      };
    },

    loadErrorPatchAction: ids => {
      return {
        type: actionTypes.loadErrorPatch,
        payload: {
          ids
        }
      };
    },

    loadingPutAction: id => {
      return {
        type: actionTypes.loadingPut,
        payload: {
          id
        }
      };
    },

    loadingDeleteWithStatusByIdAction: id => {
      return {
        type: actionTypes.loadingDeleteWithStatusById,
        payload: {
          id
        }
      };
    },

    loadErrorPutAction: id => {
      return {
        type: actionTypes.loadErrorPut,
        payload: {
          id
        }
      };
    },

    /**
     * Action creator to increment the current page for a context
     * @param {string} context
     * @returns {Object} redux action
     */
    incrementPageForContextAction: context => {
      return {
        type: actionTypes.incrementPageForContext,
        payload: {
          context
        }
      };
    },

    setPageForContextAction: (context, pageNumber) => {
      return {
        type: actionTypes.setPageForContext,
        payload: {
          context,
          pageNumber
        }
      };
    },

    removeResourceByIdAction: id => {
      return {
        type: actionTypes.removeResourceById,
        payload: {
          id
        }
      };
    }
  };
}
